import { render, staticRenderFns } from "./AdminFinalExamDateView.vue?vue&type=template&id=18b0ba80"
import script from "./AdminFinalExamDateView.vue?vue&type=script&lang=js"
export * from "./AdminFinalExamDateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports